(function () {
    'use strict';
    angular
        .module('app')
        .controller('editEmail', editEmail);
    editEmail.$inject = ['$location', '$scope', '$rootScope', '$timeout', 'editEmailsService', '$mdDialog', 'loginService']; 
    function editEmail($location, scope, $rootScope, $timeout, editEmailsService, $mdDialog, loginService) { 

        scope.editEmailDialogShown = false;
        scope.xyz = { processing: false };
        //scope.$on('editEmailTriggered', function (event, arg) {
        //    scope.onEditEmailTriggered();
        //});
        scope.loginService = loginService;

        scope.processingLabel = loginService.resourceStrings["PROCESSING"]; // "processing";

        // On click of the Assign button.
        //scope.onEditEmailTriggered = function () {

        // scope
        scope.editEmail = {};

        //scope.editEmail.to = editEmailsService.editEmail.toUserModels;
        //{ LoginName: "test", EmailAddress: "test@mail.com", custom: true, selected: true }
        scope.editEmail.to = [];
        angular.forEach(editEmailsService.editEmail.emailItem.toUserModels, function (item) {
            var newTo = {};
            newTo.Id = item.Id;
            newTo.UserName = item.UserName;
            newTo.LoginName = item.LoginName;
            newTo.EmailAddress = item.EmailAddress;
            newTo.custom = true;
            newTo.selected = true;
            scope.editEmail.to.push(newTo);
        });

        scope.editEmail.subject = editEmailsService.editEmail.emailItem.subject;
        scope.editEmail.body = editEmailsService.editEmail.emailItem.body;
        scope.editEmail.bodyTemplate = null;
        scope.editEmail.show = true;

        // dialog config
        scope.OK = loginService.resourceStrings["OK"]; // "OK";
        scope.Cancel = loginService.resourceStrings["CANCEL"]; // "Cancel";

        // Do modal.
        scope.editEmailDialogShown = true;
        //};

        scope.onEditEmailsDialogOK = function () {
            scope.xyz.processing = true;
            var sTo = editEmailsService.umToDisplay(scope.editEmail.to);
            editEmailsService.editEmail.emailItem.toUserModels = scope.editEmail.to;
            editEmailsService.editEmail.emailItem.to = sTo;
            editEmailsService.editEmail.emailItem.subject = scope.editEmail.subject;

            var text = scope.editEmail.body.replace(/<div>/g, "\r");
            text = text.replace(/<\/div>/g, "");
            text = text.replace(/<br>/g, "\r");

            editEmailsService.editEmail.emailItem.body = text;
            editEmailsService.editEmail.toCol = sTo;
            editEmailsService.editEmail.subjectCol = scope.editEmail.subject;
            editEmailsService.editEmail.bodyCol = scope.editEmail.body;
            $mdDialog.hide();
            scope.xyz.processing = false;
        };

        scope.onEditEmailsDialogCancel = function () {
            // Close dialog.
            $mdDialog.hide();
        };

        scope.editEmailsDialogClosed = function () {

        }

        activate();

        function activate() { }
    }
})();
